import $ from "jquery";
let $document;

let BaseModal;
let BillingForm;
let Dispatcher;
let DownloadStore;
let Metrics;
let ProcessButton;
let React;
let SplitButton;
let StripeStore;
let UserStore;

BaseModal = require("../components/basemodal").default;

BillingForm = require("../components/billingform").default;

Dispatcher = require("../dispatcher/dispatcher").default;

$document = require("../helpers/helpers").default.document;

DownloadStore = require("../stores/downloadstore").default;

Metrics = require("../helpers/metrics").default;

ProcessButton = require("../components/processbutton").default;

React = require("react");

SplitButton = require("../components/splitbutton").default;

StripeStore = require("../stores/stripestore").default;

UserStore = require("../stores/userstore").default;

class PostDownload extends React.Component {
    startDownload(imgType) {
        let color = DownloadStore._data.img_color;
        return Dispatcher.dispatch({
            actionType: "requestDownload",
            icon: this.props.selectedIcon,
            imgType,
            PostDownload: true,
            img_color: color
        });
    }

    resetDownloadState() {
        return Dispatcher.dispatch({
            actionType: "confirmDownload"
        });
    }

    selectAttributionText(event) {
        $(event.target).select();
        return $(".copy-help").addClass("show-copy-help");
    }

    render() {
        let actionClasses;
        let attributionButton;
        let attribution_placeholder;
        let description;
        let designer;
        let icon;
        let reDownloadButton;
        let redownloadColor;
        let title;
        icon = this.props.selectedIcon;
        attribution_placeholder =
            icon.term + " by " + icon.uploader.name + " from the Noun Project";
        actionClasses = "download-actions";
        if (UserStore.hasPremiumMarketAccess()) {
            title = gettext("Congrats, you’re NounPro!");
            designer = void 0;
            redownloadColor = "blue";
            description = (
                <p className="download-description">
                    {gettext("You just got a license to ")} {icon.term} by{" "}
                    {icon.uploader.name}
                    {gettext(
                        ", and access to unlimited royalty-free licenses to our entire icon library. "
                    )}
                    <a href="/pricing/" title="Learn More" target="_blank">
                        Learn more
                    </a>{" "}
                    {gettext("about your recurring NounPro subscription.")}
                </p>
            );
        } else {
            switch (this.props.attributed) {
                case true:
                    title = gettext("You just got an icon");
                    designer = (
                        <h2 className="designer">by {icon.uploader.name}</h2>
                    );
                    redownloadColor = "grey";
                    description = (
                        <p className="download-description">
                            {gettext(
                                "To provide proper credit, use the embedded credit already in the icon you downloaded, or you can copy the attribution text and add it to your citations, about page, or place in which you would credit work you did not create."
                            )}
                        </p>
                    );
                    attributionButton = (
                        <div className="new-form copy-attribution">
                            <input
                                onClick={this.selectAttributionText.bind(this)}
                                id="copy-attribution"
                                className="copy-input"
                                value={attribution_placeholder}
                                readOnly="true"
                            />
                            <label
                                htmlFor="copy-attribution"
                                className="copy-help"
                            >
                                Press ⌘ + C to copy ( CTRL + C on PC )
                            </label>
                            <label
                                htmlFor="copy-attribution"
                                className="copy-input-button ui_clipboard clicked"
                            />
                        </div>
                    );
                    actionClasses += " free-download";
                    break;
                case false:
                    title = gettext("You just got a license to ") + icon.term;
                    designer = (
                        <h2 className="designer">by {icon.uploader.name}</h2>
                    );
                    redownloadColor = "blue";
                    description = (
                        <p className="download-description">
                            {gettext(
                                "You can use this icon for unlimited use on any project, forever. Your purchase directly supports the creator."
                            )}
                        </p>
                    );
            }
        }
        reDownloadButton = (
            <SplitButton
                buttonState={this.props.buttonState}
                color={redownloadColor}
                iconClass="ui_download"
                initialButtonText="Re-Download"
                leftButtonText="SVG"
                rightButtonText="PNG"
                widthClass="wide"
                leftButtonCallback={this.startDownload.bind(this, "svg")}
                rightButtonCallback={this.startDownload.bind(this, "png")}
                resetState={this.resetDownloadState.bind(this)}
            />
        );

        return (
            <div className="flex-div">
                <section className="post-download twelve columns">
                    <img
                        className="creator-avatar"
                        src={this.props.creatorAvatar}
                        width="80"
                        height="80"
                    />
                    <h1 className="download-headline">{title}</h1>
                    {designer}
                    {description}
                    <div className={actionClasses}>
                        {attributionButton}
                        {reDownloadButton}
                    </div>
                </section>
            </div>
        );
    }
}

class LicenseOptions extends React.Component {
    onGiveCredit(event) {
        event.preventDefault();
        ga("send", "event", "download-test", "choice-v2", "free");
        return this.props.onGiveCredit(event);
    }

    onALaCarte(event) {
        event.preventDefault();
        ga("send", "event", "download-test", "choice-v2", "purchase");
        return this.props.onALaCarte(event);
    }

    render() {
        let aLaCarteButton;
        let buttonState;
        let giveCreditButton;
        let icon;
        let imgStyle;
        let imgType;
        icon = this.props.selectedIcon;
        imgType = this.props.imgType;
        imgStyle = {
            backgroundImage: "url(" + icon.icon_url + ")"
        };
        buttonState = "initial";
        if (this.props.downloadStatus === "PROCESSING") {
            buttonState = "processing";
        } else if (this.props.downloadStatus === "SUCCESS") {
            buttonState = "success";
        } else if (this.props.downloadStatus === "FAILURE") {
            buttonState = "failure";
        }
        aLaCarteButton = (
            <ProcessButton
                callback={this.onALaCarte.bind(this)}
                buttonState="initial"
                iconButton={true}
                buttonText="Royalty Free"
                iconClass="ui_download"
                extraClass="wide align-left"
                color="blue"
            />
        );

        giveCreditButton = (
            <ProcessButton
                callback={this.onGiveCredit.bind(this)}
                resetState={this.props.downloadConfirm}
                buttonState={buttonState}
                iconButton={true}
                buttonText="Creative Commons"
                iconClass="ui_download"
                extraClass="wide align-left"
                color="green"
            />
        );

        return (
            <div>
                <section className="download-modal-content download-modal_file-options">
                    <div className="meta-info">
                        <h1 className="download-headline icon-name">
                            {icon.term}
                        </h1>
                        <span className="designer">
                            By {icon.uploader.name}
                        </span>
                    </div>

                    <h3 className="download-license-subhead">
                        Choose a license
                    </h3>

                    <ul>
                        <li>{aLaCarteButton}</li>
                        <li className="or">or</li>
                        <li>{giveCreditButton}</li>
                    </ul>
                    <div className="whats-the-difference">
                        <span className="difference-text">
                            What’s the difference
                        </span>
                        <span className="help-container">
                            <a className="help-tip ui_help">
                                <span className="visuallyhidden">
                                    Get more help
                                </span>
                            </a>
                            <div className="help-box">
                                <h2 className="help-headline">Royalty Free</h2>
                                <p className="help-body-copy">
                                    Purchase a royalty free license for
                                    unlimited use on any project, forever. Your
                                    purchase directly supports the creator.
                                </p>
                                <h2 className="help-headline">
                                    Creative Commons
                                </h2>
                                <p className="help-body-copy">
                                    Creative Commons allows you to download for
                                    free, but you must give credit to the
                                    creator according to the{" "}
                                    <a
                                        className="text-link light"
                                        target="_blank"
                                        href="https://creativecommons.org/licenses/by/3.0/"
                                    >
                                        Creative Commons Attribution license.
                                    </a>
                                </p>
                                <a
                                    className="text-link light"
                                    target="_blank"
                                    href="https://thenounproject.zendesk.com/hc/en-us/sections/200159763-Downloading-Icons-Purchases-Receipts"
                                >
                                    Get more help
                                </a>
                            </div>
                        </span>
                    </div>
                </section>
                <div className="download-preview" style={imgStyle} />
            </div>
        );
    }
}

class ALaCarte extends React.Component {
    render() {
        let icon;
        let imgStyle;
        let imgType;
        icon = this.props.selectedIcon;
        imgType = this.props.imgType;
        imgStyle = {
            backgroundImage: "url(" + icon.icon_url + ")"
        };
        return (
            <div>
                <section className="a-la-carte six columns">
                    <div className="meta-info">
                        <h1 className="download-headline icon-name">
                            {icon.term}
                        </h1>
                        <span className="designer">
                            By {icon.uploader.name}
                        </span>
                    </div>

                    <BillingForm selectedIcon={icon} />
                </section>
                <div className="download-preview" style={imgStyle} />
            </div>
        );
    }
}

class Download_Modal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            downloadPhase: null,
            downloadStatus: null,
            icon: null,
            imgType: null,
            downloadType: null,
            modalContent: undefined,
            creatorAvatar: null
        };
    }

    onCloseModal(event) {
        if (event !== void 0) {
            event.preventDefault();
        }
        if (this.state.billingStatus !== "PROCESSING") {
            Dispatcher.dispatch({
                actionType: "abortDownload"
            });
            return this.setState({
                downloadPhase: undefined
            });
        }
    }

    updateImgType(fileType, event) {
        let newImgType;
        if (event !== void 0) {
            event.preventDefault();
        }
        newImgType = null;
        switch (fileType) {
            case "svg":
                newImgType = "svg";
                break;
            case "png":
                newImgType = "png";
        }
        if (newImgType !== null) {
            return Dispatcher.dispatch({
                actionType: "requestDownload",
                imgType: newImgType
            });
        }
    }

    onDownloadConfirm() {
        return Dispatcher.dispatch({
            actionType: "confirmDownload"
        });
    }

    giveCredit() {
        return this.requestDownload("attribution");
    }

    aLaCarte() {
        return this.requestDownload("non-attribution");
    }

    requestDownload(downloadType) {
        let color = DownloadStore._data.img_color;
        return Dispatcher.dispatch({
            actionType: "requestDownload",
            imgType: this.state.imgType,
            downloadType,
            img_color: color
        });
    }

    getCreatorAvatar(uploader_id) {
        return $.get("/accounts/" + uploader_id + "/avatar/")
            .done(
                (_this => (data, status, xhr) =>
                    _this.setState({
                        creatorAvatar: data.avatar_url
                    }))(this)
            )
            .fail(
                (_this => (data, status, xhr) =>
                    _this.setState({
                        creatorAvatar: null
                    }))(this)
            );
    }

    getCustomerData() {
        if (UserStore.getAll().user.is_anonymous === false) {
            return $.get("/get/customer/")
                .done((data, status, xhr) => {
                    if (data.ok === false) {
                        data = void 0;
                    }
                    return Dispatcher.dispatch({
                        actionType: "updateUser",
                        card: data
                    });
                })
                .fail((data, status, xhr) => {});
        }
    }

    render() {
        let modal;
        let modalContent;
        switch (this.state.downloadPhase) {
            case "SELECT_LICENSE":
                modalContent = (
                    <LicenseOptions
                        selectedIcon={this.state.icon}
                        downloadPhase={this.state.downloadPhase}
                        downloadStatus={this.state.downloadStatus}
                        downloadConfirm={this.onDownloadConfirm.bind(this)}
                        imgType={this.state.imgType}
                        onSelectImgType={this.updateImgType.bind(this)}
                        onALaCarte={this.aLaCarte.bind(this)}
                        onGiveCredit={this.giveCredit.bind(this)}
                    />
                );
                break;
            case "PAY":
                modalContent = (
                    <ALaCarte
                        selectedIcon={this.state.icon}
                        imgType={this.state.imgType}
                        onSelectImgType={this.updateImgType.bind(this)}
                        downloadStatus={this.state.downloadStatus}
                    />
                );
                break;
            case "POST_DOWNLOAD_ATTRIBUTION":
                modalContent = (
                    <PostDownload
                        attributed={true}
                        buttonState={this.state.downloadStatus}
                        selectedIcon={this.state.icon}
                        creatorAvatar={this.state.creatorAvatar}
                    />
                );
                break;
            case "POST_DOWNLOAD":
                modalContent = (
                    <PostDownload
                        attributed={false}
                        buttonState={this.state.downloadStatus}
                        selectedIcon={this.state.icon}
                        creatorAvatar={this.state.creatorAvatar}
                    />
                );
        }
        if (modalContent !== void 0) {
            modal = (
                <BaseModal
                    modalContent={modalContent}
                    onCloseModal={this.onCloseModal.bind(this)}
                    modalType="full-white"
                    className="download-modal"
                />
            );
        }
        if (this.state.downloadPhase === undefined) {
            modal = null;
        }
        return <div>{modal}</div>;
    }

    onDownloadChange() {
        let downloadData;
        let phase;
        let state;
        let status;
        downloadData = DownloadStore.getAll();
        if (downloadData.showDownloadModal === true) {
            phase = DownloadStore.getCurrentPhase();
            status = DownloadStore.getCurrentStatus();
            state = {
                downloadPhase: phase,
                downloadStatus: status,
                billingStatus: StripeStore.getCurrentStatus(),
                downloadType: downloadData.downloadType,
                imgType: downloadData.imgType
            };
            if (downloadData.pendingDownload) {
                state.icon = downloadData.pendingDownload;
                if (
                    this.state.icon === null ||
                    state.icon.id !== this.state.icon.id
                ) {
                    this.getCreatorAvatar(state.icon.uploader_id);
                }
            }
        } else {
            state = this.state;
        }
        return this.setState(state);
    }

    componentDidMount() {
        $document.bind(
            "keydown",
            (_this => event => {
                let esc;
                esc = 27;
                switch (event.keyCode) {
                    case esc:
                        if (_this.state.billingStatus !== "PROCESSING") {
                            return _this.onCloseModal();
                        }
                }
            })(this)
        );
        DownloadStore.addListener("change", this.onDownloadChange.bind(this));
        UserStore.addListener("change", this.onDownloadChange.bind(this));
        StripeStore.addListener("change", this.onDownloadChange.bind(this));
        return this.getCustomerData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.state.downloadPhase === "SELECT_LICENSE" &&
            prevState.downloadPhase !== "SELECT_LICENSE"
        ) {
            return new Metrics().license_options(this.state.icon.id);
        }
    }

    componentWillUnmount() {
        DownloadStore.removeListener(
            "change",
            this.onDownloadChange.bind(this)
        );
        UserStore.removeListener("change", this.onDownloadChange.bind(this));
        return StripeStore.removeListener(
            "change",
            this.onDownloadChange.bind(this)
        );
    }
}

export default Download_Modal;
